import React from 'react';
import {Box, Input, MenuWrapper, MenuItem} from './Styled';
import Loader from '../common/Loader/Loader';

const KEY_UP = 38;
const KEY_DOWN = 40;
const KEY_ENTER = 13;

export default class Search extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cursor: null,
            renderMenu: false,
            value: "",
            items: []
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.items.length > 0) {
            this.setState({
                renderMenu: true,
                items: nextProps.items
            });
        }
    }

    handleOnBlur = () => {
        this.setState({ renderMenu: false });
    }
    handleOnFocus = () => { this.setState({ renderMenu: (this.state.items.length > 0 && this.state.value.length > 0) }); }
    onMouseEnter = () => { this.setState({ cursor: null }); } // Clear cursor so that two dont hover

    handleChange = (event) => {
        // The changed lead to input being blank , remove menu and reset cursor
        if (event.target.value === '') {
            this.setState({
                renderMenu: false,
                value: event.target.value,
                cursor: null
            });
            return;
        }
        // Update state value and reset cursor again
        this.setState({ value: event.target.value, cursor: null });
        this.props.inputChange(event.target.value);

    }

    handleKeyDown = (e) => {
        let { cursor, items } = this.state;

        if (e.keyCode === KEY_UP) {
            if (cursor === null) {
                cursor = items.length - 1;
            } else if (cursor === 0) {
                cursor = null;
            } else {
                cursor--;
            }
            e.preventDefault();
        } else if (e.keyCode === KEY_DOWN) {
            if (cursor === null) {
                cursor = 0;
            } else if (cursor === items.length - 1) {
                // Reset to begining
                cursor = null;
            } else {
                cursor++;
            }
            e.preventDefault();
        }

        this.setState({ cursor });

        if (e.keyCode === KEY_ENTER && this.state.items.length === 1 ) {
            this.props.itemSelected(this.state.items[0]);
            e.preventDefault();
        } else if (e.keyCode === KEY_ENTER && cursor !== null) {
            // Fire item select action if enter is pressed and cursor is active
            this.props.itemSelected(this.state.items[cursor]);
            e.preventDefault();
        } else if (e.keyCode === KEY_ENTER && cursor === null) {
            this.props.onSearch(this.state.value);
            e.preventDefault();
        }
      }

    render() {
        const loadingIndicator = this.props.isLoading ? (<Loader className="search-load"/>) : null;

        if (this.state.renderMenu) {
            const ComponentToRender = this.props.menuItemCell;
            const FooterToRender = this.props.menuItemFooter;
            var menuList = (
                <MenuWrapper>
                    {
                        this.state.items.map((i, index) => {
                            var active = false;
                            if (this.state.cursor === index) {
                                active = true;
                            }
                            return (
                            <MenuItem
                                onMouseEnter={this.onMouseEnter}
                                onMouseDown={() => { this.props.itemSelected(i) }}
                                key={index}
                                active={active}>
                                <ComponentToRender item={i} />
                            </MenuItem>)
                        })
                    }
                    <FooterToRender term={this.state.value}
                    footerViewAllClicked={this.props.footerViewAllClicked}
                    />
                </MenuWrapper>
            );
        }

        return (
            <div role="search">
                <label htmlFor="search-bar" className="hidden">Search: </label>
                <Box isDark={this.props.isDark} Click={() => {this.textInput.focus();}}>
                    <Input
                        aria-label="Search for a product"
                        id="search-bar"
                        isDark={this.props.isDark}
                        innerRef={(input) => { this.textInput = input; }}
                        onFocus={this.handleOnFocus}
                        onBlur={this.handleOnBlur}
                        value={this.state.value}
                        placeholder={this.props.placeholder}
                        onChange={this.handleChange}
                        onKeyDown={this.handleKeyDown}
                        />
                    {menuList}
                    {loadingIndicator}
                </Box>
            </div>
        );
    }
  }



// WEBPACK FOOTER //
// ./src/components/Search/Search.js